var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.MERIT.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('v-divider', {
    staticClass: "primary"
  }), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("특별한 작품")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("신중한 맞춤화 전략")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("프라이빗 세일은 희귀하거나, 독특한 혹은 특별한 작품을 구입하려는 경우에 유용합니다.")]), _c('li', [_vm._v("프리이빗 세일은 수집가의 '위시 리스트(Wish list)'와 연결하는 신중하고 고도로 맞춤화된 서비스입니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon2.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("고정된 가격")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("가격 통제 유리")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("경매에서의 작품가격은 경합에 따라 유동적이며, 정확한 예측이 어렵습니다.")]), _c('li', [_vm._v("반면, 프라이빗 세일에서의 작품가격은 고정되어 있어서, 가격 통제가 매우 유리합니다.")]), _c('li', [_vm._v("따라서, 프라이빗 세일에서는 고정된 가격으로 특별/특정 작품을 안정적으로 구매할 수 있습니다."), _c('br'), _vm._v("※ 세심하지 못한 사적(私的)인 가격결정은 경매시장에 혼돈을 주기도 합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon3.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("편안한 일정")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("\"순간 포착\" 가능")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("경매는 일정이 확정되어 있습니다. 특히, 봄과 가을에 분주합니다.")]), _c('li', [_vm._v("프라이빗 세일은 경매일정과 상관없이, 고객 중심으로, 고객의 일정에 맞추어 작품을 매매할 수 있는 탄력적인 서비스입니다.")]), _c('li', [_vm._v("잠재 구매자가 있는 경우, 경매보다 훨씬 신속하고, 정확하게 \"순간 포착(capture the moment)\"하여 매매할 수 있습니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon4.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("낮은 부담감")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("마음 편안한 거래 (잠재적 간섭의 제거)")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("대중의 이목이 집중되어 있거나, 사회적 이슈가 우려되는 작품이 있습니다.")]), _c('li', [_vm._v("괜히 불필요한 오해의 소지를 불러 일으켜서, 간섭을 받거나 곤란해 질 수도 있습니다.")]), _c('li', [_vm._v("또는, 공개 경매에서 판매하는 것이 비현실적이거나, 바람직하지 않은 경우가 있습니다.")]), _c('li', [_vm._v("이런 경우에, 프라이빗 세일은 노출의 최소화를 통해, 고객의 심리적인 부담감을 낮춰 드립니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon5.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("낮은 위험성")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("항상 플랜(Plan) B가 존재")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("공개경매에서 유찰될 경우, 작품의 품격과 가격에 악영향을 미칠 수 있습니다.")]), _c('li', [_vm._v("프라이빗 세일은 유찰에 따른 작품 리스크를 낮춰 줍니다.")]), _c('li', [_vm._v("프라이빗 세일에서 작품을 판매하지 못한 경우 언제든지 경매 등 다른 방식으로 판매할 수 있습니다."), _c('br'), _vm._v("즉, 항상 플랜 B가 존재합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-advantage-icon6.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("높은 보안성")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h5', {
    staticClass: "tit tit--xs font-weight-medium"
  }, [_vm._v("안전한 거래 + 장기 투자에 유리")])]), _c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("프라이빗 세일에서 고객의 신원 및 개인판매 문의는 엄격하게 기밀로 유지되곤 합니다.")]), _c('li', [_vm._v("가격도 공개되지 않으며, 대부분의 업무절차를 매우 신중하고, 조심스럽게 진행합니다.")]), _c('li', [_vm._v("구매한 가격은 비밀로 유지되기 때문에, 장기 투자자에게는 더욱 큰 힘을 발휘할 수 있을 것입니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1)], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }